import { api } from '@api/api2';
import type { GetObjectsWithSearchPayload } from './types';

export const getObjectsWithSearch = (payload: GetObjectsWithSearchPayload) =>
  api.v4('get', 'area/simple-search', payload);
